// extracted by mini-css-extract-plugin
module.exports = {"header":"fF3D33p","social-items":"jvlb2xS","socialItems":"jvlb2xS","social-item":"vfStewT","socialItem":"vfStewT"};